import Pjax from "pjax"
import { ClientPage } from "../../submodules/rapdv/client/elements/PagesCtrl"

export class PageManageLeads implements ClientPage {
  private pjax: Pjax

  getPageId = (): string => "manage-leads"

  execute = (pjax: Pjax): void => {
    this.pjax = pjax

    const importButton = document.querySelector<HTMLButtonElement>(".js-import-leads")
    const fileInput = document.querySelector<HTMLInputElement>(".js-import-leads-file")
    if (!importButton || !fileInput) return

    importButton.addEventListener("click", () => fileInput.click())
    fileInput.addEventListener("change", () => this.importFile(importButton, fileInput))
  }

  private importFile = async (importButton: HTMLButtonElement, fileInput: HTMLInputElement): Promise<void> => {
    const file = fileInput.files?.[0]
    if (!file) return

    importButton.disabled = true

    try {
      const formData = new FormData()
      formData.append("file", file)

      const csrfToken = document.querySelector<HTMLInputElement>('input[name="_csrf"]')?.value ?? ""
      const response = await fetch("/api/v1/leads/import", {
        method: "POST",
        headers: { "X-CSRF-Token": csrfToken },
        body: formData
      })

      const result = await response.json().catch(() => null)
      if (!response.ok || !result?.success) {
        window.alert(result?.error ?? "Couldn't import leads")
        return
      }

      this.pjax.loadUrl(window.location.pathname + window.location.search)
    } catch (error) {
      window.alert("Couldn't import leads")
    } finally {
      importButton.disabled = false
      fileInput.value = ""
    }
  }

  onPageClose = (): void => {}
}
